// In sviluppo usa un path relativo: passa dal dev server (vedi src/setupProxy.js)
// che inoltra a localhost:3500. Così funziona anche dietro un singolo tunnel ngrok.
export const BASE_URL = process.env.NODE_ENV === "production" ? 'https://webapp.wine2trace.com/api' : '/api';
